"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextFormatIcon = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["selectedColor"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TextFormatIcon = exports.TextFormatIcon = /*#__PURE__*/_react["default"].forwardRef(function TextFormatIcon(props, ref) {
  var selectedColor = props.selectedColor,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], _extends({
    ref: ref,
    viewBox: "0 0 28 33.33"
  }, otherProps), /*#__PURE__*/_react["default"].createElement("rect", {
    y: "29.33",
    width: "28",
    height: "4",
    fill: selectedColor,
    style: {
      fill: selectedColor
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.82,27l10-26h3.71L26.18,27H22.25l-3-7.89H8.33L5.47,27Zm7.51-10.7h8.82l-2.72-7.2c-.83-2.19-1.44-4-1.84-5.39a33.46,33.46,0,0,1-1.41,5Z",
    transform: "translate(0 -1.03)"
  }));
});